import React, { useState, useEffect, useMemo } from 'react';
import Header from './Header';
import Footer from './Footer';
import { useParams } from 'react-router-dom';
import { API_URL, BASE_URL } from './Config';
import config from "./common/Config";
import { toast } from "sonner";
import generateTripSummaryPDF from "./TripSummaryPDF";
import generateTripSummaryPDF_sdm from "./generateTripSummaryPDF_sdm";
import {
	Box,
	Paper,
	Typography,
	TableContainer,
	Table,
	TableHead,
	TableBody,
	TableRow,
	TableCell,
	Button,
	Grid,
} from "@mui/material";
import "./common/commonStyles.css";

const ClosedTripSummary = () => {
	const { tripId } = useParams();

	const [tripNumber, setTripNumber] = useState([]);
	const [driverName, setDriverName] = useState([]);
	const [vehicle, setVehicle] = useState([]);
	const [date, setDate] = useState([]);
	const [PartialUndelivered, setPartialUndelivered] = useState([]);

	const [totalProductsBox, setTotalProductsBox] = useState([]);
	const [totalProductsPiece, setTotalProductsPiece] = useState([]);
	const [totalBoxPrice, setTotalBoxPrice] = useState([]);
	const [totalPiecePrice, setTotalPiecePrice] = useState([]);
	const [totalProductsPrice, setTotalProductsPrice] = useState([]);

	const [deliveredProductsBox, setDeliveredProductsBox] = useState([]);
	const [deliveredProductsPices, setDeliveredProductsPices] = useState([]);
	const [deliveredBoxPrice, setDeliveredBoxPrice] = useState([]);
	const [deliveredPiecePrice, setDeliveredPiecePrice] = useState([]);
	const [TotaldeliveredPrice, setTotalDeliveredPrice] = useState([]);

	const [undeliveredProductsBox, setUndeliveredProductsBox] = useState([]);
	const [undeliveredProductsPices, setUndeliveredProductsPices] = useState([]);
	const [undeliveredBoxPrice, setUndeliveredBoxPrice] = useState([]);
	const [undeliveredPiecePrice, setUndeliveredPiecePrice] = useState([]);
	const [totalUndeliveredPrice, setTotalUndeliveredPrice] = useState([]);

	const [returnProductsBox, setReturnProductsBox] = useState([]);
	const [returnProductsPices, setReturnProductsPices] = useState([]);
	const [returnBoxPrice, setReturnBoxPrice] = useState([]);
	const [returnPiecePrice, setReturnPiecePrice] = useState([]);
	const [totalReturnPrice, setTotalReturnPrice] = useState([]);

	const [TripOrder, setTripOrder] = useState([]);
	const [loading, setLoading] = useState(false);
	const accessToken = localStorage.getItem('accessToken');
	const company_tax_type = localStorage.getItem('company_tax_type');
	const currencySymbol = localStorage.getItem('currencySymbol');

	const handleGeneratePDF = (e, tripId) => {
		if (accessToken == "sdm") {
			generateTripSummaryPDF_sdm(tripId);
		} else {
			generateTripSummaryPDF(tripId);
		}
	};

	const fetchData = async () => {
		setLoading(true);
		const formData = new FormData();
		formData.append('tripId', tripId);
		const apiUrl = `${API_URL}/get_trip_summary_details`;
		try {
			const response = await fetch(apiUrl, {
				method: 'POST',
				headers: {
					authorization: `Bearer ${accessToken}`,
				},
				body: formData,
			});

			if (!response.ok) {
				throw new Error('Failed to fetch new sales data');
			}

			const data = await response.json();
			const tripData = data.data;

			setTripNumber(tripData.trip_number);
			setDriverName(tripData.driver);
			setVehicle(tripData.vehicle);
			setDate(tripData.date);

			setTotalProductsBox(tripData.total_products_box);
			setTotalProductsPiece(tripData.total_products_piece);
			setTotalBoxPrice(parseFloat(tripData.total_box_price).toFixed(2));
			setTotalPiecePrice(parseFloat(tripData.total_piece_price).toFixed(2));
			setTotalProductsPrice(parseFloat(tripData.total_piece_price + tripData.total_box_price).toFixed(2));

			setDeliveredProductsBox(tripData.total_delivered_box);
			setDeliveredProductsPices(tripData.total_delivered_piece);
			setDeliveredBoxPrice(parseFloat(tripData.total_delivered_box_price).toFixed(2));
			setDeliveredPiecePrice(parseFloat(tripData.total_delivered_piece_price).toFixed(2));
			setTotalDeliveredPrice(parseFloat(tripData.total_delivered_box_price + tripData.total_delivered_piece_price).toFixed(2));

			setUndeliveredProductsBox(tripData.undelivered_products_box);
			setUndeliveredProductsPices(tripData.undelivered_products_piece);
			setUndeliveredBoxPrice(parseFloat(tripData.undelivered_box_price).toFixed(2));
			setUndeliveredPiecePrice(parseFloat(tripData.undelivered_piece_price).toFixed(2));
			setTotalUndeliveredPrice(parseFloat(tripData.undelivered_box_price + tripData.undelivered_piece_price).toFixed(2));

			setReturnProductsBox(tripData.return_products_box);
			setReturnProductsPices(tripData.return_products_piece);
			setReturnBoxPrice(parseFloat(tripData.return_box_price).toFixed(2));
			setReturnPiecePrice(parseFloat(tripData.return_piece_price).toFixed(2));
			setTotalReturnPrice(parseFloat(tripData.return_box_price + tripData.return_piece_price).toFixed(2));

			setTripOrder(tripData.trip_order);
			setPartialUndelivered(tripData.partial_undelivered);
		} catch (error) {
			console.error('Error fetching new sales data:', error);
			toast.error("Failed to load trip summary");
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (accessToken === null) {
			window.location.href = `${config.BASE_URL}/login`;
			return;
		}
		fetchData();
	}, []);

	const orderTotals = useMemo(() => {
		let totalAmount = 0;
		let totalCollect = 0;
		let cash = 0;
		let cheque = 0;
		let card = 0;

		TripOrder.forEach((item) => {
			totalAmount += parseFloat(item.grand_total) || 0;
			totalCollect += parseFloat(item.driver_collect) || 0;

			if (item.type === 'cash') {
				cash += parseFloat(item.driver_collect) || 0;
			}
			if (item.type === 'card') {
				card += parseFloat(item.driver_collect) || 0;
			}
			if (item.type === 'cheque') {
				cheque += parseFloat(item.driver_collect) || 0;
			}
		});

		return { totalAmount, totalCollect, cash, cheque, card };
	}, [TripOrder]);

	const undeliveredProducts = useMemo(() => {
		return PartialUndelivered.filter(item => item.status !== 'Return');
	}, [PartialUndelivered]);

	const returnProducts = useMemo(() => {
		return PartialUndelivered.filter(item => item.status === 'Return');
	}, [PartialUndelivered]);

	const totalUndeliveredQty = useMemo(() => {
		return undeliveredProducts.reduce((sum, item) => sum + (parseFloat(item.not_delivered_qty) || 0), 0);
	}, [undeliveredProducts]);

	const totalReturnQty = useMemo(() => {
		return returnProducts.reduce((sum, item) => sum + (parseFloat(item.not_delivered_qty) || 0), 0);
	}, [returnProducts]);

	return (
		<>
			<Box className="page-container">
					<Paper
						className="paper-style">
						<Box sx={{ px:2, py:1.2, borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
							<Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 2 }}>
								<Typography sx={{ fontWeight: 500, color: "#212b36", fontSize: "1.125rem" }}>
									Trip Summary - {tripNumber}
								</Typography>
								<Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
									<Typography variant="body2" sx={{ color: "#637381", fontSize: "0.875rem" }}>
										<span style={{ fontWeight: 500, color: "#212b36" }}>Date - </span> {date}
									</Typography>
									<Typography variant="body2" sx={{ color: "#637381", fontSize: "0.875rem" }}>
										<span style={{ fontWeight: 500, color: "#212b36" }}>Driver - </span> {driverName}
									</Typography>
									<Typography variant="body2" sx={{ color: "#637381", fontSize: "0.875rem" }}>
										<span style={{ fontWeight: 500, color: "#212b36" }}>Vehicle - </span> {vehicle}
									</Typography>
									<Button
										variant="contained"
										onClick={(e) => handleGeneratePDF(e, tripId)}
										className="button-variant-contained"
									>
										Print
									</Button>
								</Box>
							</Box>
						</Box>
						<Box sx={{ p: 2 }}>
							<Grid container spacing={2}>
								<Grid item xs={12} sm={6} lg={3}>
									<Paper
										elevation={0}
										sx={{
											border: "1px solid rgba(145, 158, 171, 0.16)",
											borderRadius: 1,
											overflow: "hidden",
										}}
									>
										<Table size="small" className="table-cell-border">
											<TableHead>
												<TableRow className="table-cell-header">
													<TableCell colSpan={2} align="center" sx={{ fontWeight: 600, fontSize: "0.75rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														Goods Taken
													</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												<TableRow>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														{totalProductsBox} box
													</TableCell>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														{currencySymbol} {totalBoxPrice}
													</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														{totalProductsPiece} Psc
													</TableCell>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														{currencySymbol} {totalPiecePrice}
													</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ fontWeight: 600, fontSize: "0.8rem", color: "#212b36" }}>
														Total
													</TableCell>
													<TableCell sx={{ fontWeight: 600, fontSize: "0.8rem", color: "#212b36" }}>
														{currencySymbol} {(totalProductsPrice ?? 0)}
													</TableCell>
												</TableRow>
											</TableBody>
										</Table>
									</Paper>
								</Grid>
								<Grid item xs={12} sm={6} lg={3}>
									<Paper
										elevation={0}
										sx={{
											border: "1px solid rgba(145, 158, 171, 0.16)",
											borderRadius: 1,
											overflow: "hidden",
										}}
									>
										<Table size="small" className="table-cell-border">
											<TableHead>
												<TableRow className="table-cell-header">
													<TableCell colSpan={2} align="center" sx={{ fontWeight: 600, fontSize: "0.75rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														Goods Delivered
													</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												<TableRow>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														{deliveredProductsBox} box
													</TableCell>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														{currencySymbol} {deliveredBoxPrice}
													</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														{deliveredProductsPices} Psc
													</TableCell>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														{currencySymbol} {deliveredPiecePrice}
													</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ fontWeight: 600, fontSize: "0.8rem", color: "#212b36" }}>
														Total
													</TableCell>
													<TableCell sx={{ fontWeight: 600, fontSize: "0.8rem", color: "#212b36" }}>
														{currencySymbol} {TotaldeliveredPrice}
													</TableCell>
												</TableRow>
											</TableBody>
										</Table>
									</Paper>
								</Grid>
								<Grid item xs={12} sm={6} lg={3}>
									<Paper
										elevation={0}
										sx={{
											border: "1px solid rgba(145, 158, 171, 0.16)",
											borderRadius: 1,
											overflow: "hidden",
										}}
									>
										<Table size="small" className="table-cell-border">
											<TableHead>
												<TableRow className="table-cell-header">
													<TableCell colSpan={2} align="center" >
														Goods Undelivered
													</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												<TableRow>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														{undeliveredProductsBox} box
													</TableCell>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														{currencySymbol} {undeliveredBoxPrice}
													</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														{undeliveredProductsPices} Psc
													</TableCell>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														{currencySymbol} {undeliveredPiecePrice}
													</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ fontWeight: 600, fontSize: "0.8rem", color: "#212b36" }}>
														Total
													</TableCell>
													<TableCell sx={{ fontWeight: 600, fontSize: "0.8rem", color: "#212b36" }}>
														{currencySymbol} {totalUndeliveredPrice}
													</TableCell>
												</TableRow>
											</TableBody>
										</Table>
									</Paper>
								</Grid>
								<Grid item xs={12} sm={6} lg={3}>
									<Paper
										elevation={0}
										sx={{
											border: "1px solid rgba(145, 158, 171, 0.16)",
											borderRadius: 1,
											overflow: "hidden",
										}}
									>
										<Table size="small" className="table-cell-border">
											<TableHead>
												<TableRow className="table-cell-header">
													<TableCell colSpan={2} align="center" sx={{ fontWeight: 600, fontSize: "0.75rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														Goods Return
													</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												<TableRow>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														{returnProductsBox} box
													</TableCell>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														{currencySymbol} {returnBoxPrice}
													</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														{returnProductsPices} Psc
													</TableCell>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														{currencySymbol} {returnPiecePrice}
													</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ fontWeight: 600, fontSize: "0.8rem", color: "#212b36" }}>
														Total
													</TableCell>
													<TableCell sx={{ fontWeight: 600, fontSize: "0.8rem", color: "#212b36" }}>
														{currencySymbol} {totalReturnPrice}
													</TableCell>
												</TableRow>
											</TableBody>
										</Table>
									</Paper>
								</Grid>
							</Grid>
						</Box>
					</Paper>

					<Box sx={{ mt: 3 }}>
						<Paper
							elevation={0}
							sx={{
								borderRadius: 2,
								border: "1px solid rgba(145, 158, 171, 0.16)",
								overflow: "hidden",
								backgroundColor: "#fff",
								mb: 3,
							}}
						>
							<Box sx={{ px: 2, py:1 }}>
								<Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#212b36" }}>
									Order Details
								</Typography>
							</Box>
							<TableContainer sx={{ width: "100%" }}>
								<Table
									size="medium"
									className="table-cell-border"
								>
									<TableHead>
										<TableRow className="table-cell-header">
											{[
												"#",
												"Customers (A/C No)",
												"Order ID",
												"Credit Type",
												"Inv. Amt",
												"Previous Dues",
												"Total Dues",
												"Collected",
												"Type"
											].map((header) => {
												let align = "left";
												if (header === "#" || header === "Order ID" || header === "Credit Type" || header === "Type") {
													align = "center";
												} else if (header === "Inv. Amt" || header === "Previous Dues" || header === "Total Dues" || header === "Collected") {
													align = "right";
												}
												return (
													<TableCell
														key={header}
														align={align}
														sx={{
															fontWeight: 600,
															fontSize: '0.75rem',
															color: '#212b36',
															letterSpacing: 0.5,
															py: 1,
														}}
													>
														{header}
													</TableCell>
												);
											})}
										</TableRow>
									</TableHead>
									<TableBody>
										{loading ? (
											<TableRow>
												<TableCell colSpan={9} align="center" sx={{ py: 4 }}>
													<Typography variant="body2" color="text.secondary">
														Loading...
													</Typography>
												</TableCell>
											</TableRow>
										) : TripOrder.length > 0 ? (
											TripOrder.map((item, index) => (
												<TableRow
													key={item.reference_no || index}
													hover
													sx={{
														"&:hover": {
															backgroundColor: "rgba(145, 158, 171, 0.04)"
														},
														borderBottom: "1px solid rgba(145, 158, 171, 0.16)"
													}}
												>
													<TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
														{index + 1}
													</TableCell>
													<TableCell sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
														{`${item.customerName} (${item.customerAccountNo})`}
													</TableCell>
													<TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
														{item.reference_no}
													</TableCell>
													<TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
														{item.credit_type_name}
													</TableCell>
													<TableCell align="right" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36", fontWeight: 500 }}>
														{currencySymbol} {parseFloat(item.grand_total).toFixed(2)}
													</TableCell>
													<TableCell align="right" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
														{currencySymbol} {parseFloat(item.previous_dues).toFixed(2)}
													</TableCell>
													<TableCell align="right" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
														{currencySymbol} {parseFloat(item.total_dev).toFixed(2)}
													</TableCell>
													<TableCell align="right" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36", fontWeight: 500 }}>
														{currencySymbol} {parseFloat(item.driver_collect).toFixed(2)}
													</TableCell>
													<TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
														{item.type === '' ? 'Un-paid' : item.type}
													</TableCell>
												</TableRow>
											))
										) : (
											<TableRow>
												<TableCell colSpan={9} align="center" sx={{ py: 4 }}>
													<Typography variant="body2">
														No records found.
													</Typography>
												</TableCell>
											</TableRow>
										)}
									</TableBody>
								</Table>
							</TableContainer>
							{TripOrder.length > 0 && (
								<Box sx={{ px: 2, py: 2, borderTop: "1px solid rgba(145, 158, 171, 0.16)", backgroundColor: "#f5f7fa" }}>
									<Grid container spacing={2} alignItems="center">
										<Grid item xs={12} md={4}>
											<Typography variant="body2" sx={{ fontSize: "0.75rem", fontWeight: 600, color: "#212b36", textAlign: { xs: "left", md: "right" } }}>
												Cash: {currencySymbol} {orderTotals.cash.toFixed(2)}&nbsp;&nbsp;&nbsp;
												Card: {currencySymbol} {orderTotals.card.toFixed(2)}&nbsp;&nbsp;&nbsp;
												Cheque: {currencySymbol} {orderTotals.cheque.toFixed(2)}
											</Typography>
										</Grid>
										<Grid item xs={12} md={2}>
											<Typography variant="body2" sx={{ fontSize: "0.75rem", fontWeight: 600, color: "#212b36" }}>
												Total Amount:
											</Typography>
										</Grid>
										<Grid item xs={12} md={2}>
											<Typography variant="body2" sx={{ fontSize: "0.75rem", fontWeight: 600, color: "#212b36" }}>
												{currencySymbol} {orderTotals.totalAmount.toFixed(2)}
											</Typography>
										</Grid>
										<Grid item xs={12} md={2}>
											<Typography variant="body2" sx={{ fontSize: "0.75rem", fontWeight: 600, color: "#212b36", textAlign: { xs: "left", md: "right" } }}>
												Total Collect:
											</Typography>
										</Grid>
										<Grid item xs={12} md={2}>
											<Typography variant="body2" sx={{ fontSize: "0.75rem", fontWeight: 600, color: "#212b36", textAlign: { xs: "left", md: "right" } }}>
												{currencySymbol} {orderTotals.totalCollect.toFixed(2)}
											</Typography>
										</Grid>
									</Grid>
								</Box>
							)}
						</Paper>
					</Box>

					<Box sx={{ mt: 3 }}>
						<Paper
							elevation={0}
							sx={{
								borderRadius: 2,
								border: "1px solid rgba(145, 158, 171, 0.16)",
								overflow: "hidden",
								backgroundColor: "#fff",
								mb: 3,
							}}
						>
							<Box sx={{ px: 2, py: 1 }}>
								<Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#212b36" }}>
									Undelivered Product List
								</Typography>
							</Box>
							<TableContainer sx={{ width: "100%" }}>
								<Table
									size="medium"
									className="table-cell-border"
								>
									<TableHead>
										<TableRow className="table-cell-header">
											{[
												"#",
												"Order Id",
												"Product Name",
												"Undeli.Qty",
												"Order Type",
												"Reason",
												"Status"
											].map((header) => {
												let align = "left";
												if (header === "#" || header === "Order Id" || header === "Undeli.Qty" || header === "Order Type" || header === "Status") {
													align = "center";
												}
												return (
													<TableCell
														key={header}
														align={align}
														sx={{
															fontWeight: 600,
															fontSize: '0.75rem',
															color: '#212b36',
															letterSpacing: 0.5,
															py: 1,
														}}
													>
														{header}
													</TableCell>
												);
											})}
										</TableRow>
									</TableHead>
									<TableBody>
										{undeliveredProducts.length > 0 ? (
											undeliveredProducts.map((item, index) => (
												<TableRow
													key={item.reference_no || index}
													hover
													sx={{
														"&:hover": {
															backgroundColor: "rgba(145, 158, 171, 0.04)"
														},
														borderBottom: "1px solid rgba(145, 158, 171, 0.16)"
													}}
												>
													<TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
														{index + 1}
													</TableCell>
													<TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
														{item.reference_no}
													</TableCell>
													<TableCell sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
														{`${item.productName} (${item.productCode})`}
													</TableCell>
													<TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
														{item.not_delivered_qty}
													</TableCell>
													<TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
														{item.order_type}
													</TableCell>
													<TableCell sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
														{item.reason}
													</TableCell>
													<TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
														{item.status}
													</TableCell>
												</TableRow>
											))
										) : (
											<TableRow>
												<TableCell colSpan={7} align="center" sx={{ py: 4 }}>
													<Typography variant="body2">
														No records found.
													</Typography>
												</TableCell>
											</TableRow>
										)}
									</TableBody>
								</Table>
							</TableContainer>
							{undeliveredProducts.length > 0 && (
								<Box sx={{ px: 2, py: 2, borderTop: "1px solid rgba(145, 158, 171, 0.16)", backgroundColor: "#f5f7fa" }}>
									<Grid container spacing={2} alignItems="center">
										<Grid item xs={12} md={3}>
											<Typography variant="body2" sx={{ fontSize: "0.75rem", fontWeight: 600, color: "#212b36", textAlign: { xs: "left", md: "right" } }}>
												Total Products: {undeliveredProducts.length}
											</Typography>
										</Grid>
										<Grid item xs={12} md={3}>
											<Typography variant="body2" sx={{ fontSize: "0.75rem", fontWeight: 600, color: "#212b36", textAlign: "center" }}>
												Total Undelivered Qty:
											</Typography>
										</Grid>
										<Grid item xs={12} md={3}>
											<Typography variant="body2" sx={{ fontSize: "0.75rem", fontWeight: 600, color: "#212b36", textAlign: "center" }}>
												{totalUndeliveredQty}
											</Typography>
										</Grid>
									</Grid>
								</Box>
							)}
						</Paper>
					</Box>

					<Box sx={{ mt: 3 }}>
						<Paper
							elevation={0}
							sx={{
								borderRadius: 2,
								border: "1px solid rgba(145, 158, 171, 0.16)",
								overflow: "hidden",
								backgroundColor: "#fff",
							}}
						>
							<Box sx={{ px: 2, py: 1 }}>
								<Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#212b36" }}>
									Return Product List
								</Typography>
							</Box>
							<TableContainer sx={{ width: "100%" }}>
								<Table
									size="medium"
									className="table-cell-border"
								>
									<TableHead>
										<TableRow className="table-cell-header">
											{[
												"#",
												"Order Id",
												"Product Name",
												"Undeli.Qty",
												"Order Type",
												"Reason",
												"Status"
											].map((header) => {
												let align = "left";
												if (header === "#" || header === "Order Id" || header === "Undeli.Qty" || header === "Order Type" || header === "Status") {
													align = "center";
												}
												return (
													<TableCell
														key={header}
														align={align}
														sx={{
															fontWeight: 600,
															fontSize: '0.75rem',
															color: '#212b36',
															letterSpacing: 0.5,
															py: 1,
														}}
													>
														{header}
													</TableCell>
												);
											})}
										</TableRow>
									</TableHead>
									<TableBody>
										{returnProducts.length > 0 ? (
											returnProducts.map((item, index) => (
												<TableRow
													key={item.reference_no || index}
													hover
													sx={{
														"&:hover": {
															backgroundColor: "rgba(145, 158, 171, 0.04)"
														},
														borderBottom: "1px solid rgba(145, 158, 171, 0.16)"
													}}
												>
													<TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
														{index + 1}
													</TableCell>
													<TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
														{item.reference_no}
													</TableCell>
													<TableCell sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
														{`${item.productName} (${item.productCode})`}
													</TableCell>
													<TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
														{item.not_delivered_qty}
													</TableCell>
													<TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
														{item.order_type}
													</TableCell>
													<TableCell sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
														{item.reason}
													</TableCell>
													<TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
														{item.status}
													</TableCell>
												</TableRow>
											))
										) : (
											<TableRow>
												<TableCell colSpan={7} align="center" sx={{ py: 4 }}>
													<Typography variant="body2">
														No records found.
													</Typography>
												</TableCell>
											</TableRow>
										)}
									</TableBody>
								</Table>
							</TableContainer>
							{returnProducts.length > 0 && (
								<Box sx={{ px: 2, py: 2, borderTop: "1px solid rgba(145, 158, 171, 0.16)", backgroundColor: "#f5f7fa" }}>
									<Grid container spacing={2} alignItems="center">
										<Grid item xs={12} md={3}>
											<Typography variant="body2" sx={{ fontSize: "0.75rem", fontWeight: 600, color: "#212b36", textAlign: { xs: "left", md: "right" } }}>
												Total Products: {returnProducts.length}
											</Typography>
										</Grid>
										<Grid item xs={12} md={3}>
											<Typography variant="body2" sx={{ fontSize: "0.75rem", fontWeight: 600, color: "#212b36", textAlign: "center" }}>
												Total Undelivered Qty:
											</Typography>
										</Grid>
										<Grid item xs={12} md={3}>
											<Typography variant="body2" sx={{ fontSize: "0.75rem", fontWeight: 600, color: "#212b36", textAlign: "center" }}>
												{totalReturnQty}
											</Typography>
										</Grid>
									</Grid>
								</Box>
							)}
						</Paper>
					</Box>
				</Box>
		</>
	);
};

export default ClosedTripSummary;
